import * as React from 'react'
import HTag from 'components/common/HTag'
import SanityBlock from 'components/common/SanityBlock'
import CTALink from 'components/common/CTALink'
import Img from 'components/common/Img'
import HexPattern from 'components/common/HexPattern'
import clsx from 'clsx'
import * as css from './HeroGrayed.module.css'

const HeroGrayed = ({ heading, _rawContent, cta, image, imageOnRight }) => (
	<section className={css.root}>
		<figure className="grayscale self-stretch">
			<Img className="h-full" {...image} />
		</figure>

		<div className={clsx(
			'grid gap-8 relative z-[1] bg-ft-gray-light/80 max-w-[600px] p-12 <md:px-8 md:my-8 <md:!order-1 <md:m-4 <md:!-mt-20',
			imageOnRight ? 'md:-order-1 md:translate-x-20 md:ml-auto' : 'md:-translate-x-20')
		}>
			<HTag className="technical-lg text-xl" {...heading} />
			<SanityBlock body={_rawContent} />
			<CTALink {...cta} />
		</div>

		<HexPattern className={clsx(
			'<md:left-0 <md:bottom-0',
			imageOnRight
				? 'md:left-0 md:top-1/2 md:-translate-y-1/2'
				: 'md:right-0 md:-scale-x-100 md:bottom-8'
		)} />
	</section>
)

export default HeroGrayed
